import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OverlayModule, ConnectedPosition } from '@angular/cdk/overlay';
import { TooltipModule } from 'primeng/tooltip';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PORTAL_SECTIONS, PORTAL_USER_MENU } from '../data/portal-nav';
import { NavItem } from '../data/nav-item.model';
import { NavSection } from '../data/nav-section.model';
import { PortalNavService } from './portal-nav.service';
import { PortalUserService } from './portal-user.service';
import { ThemeService } from './theme.service';
import { CuposFacade } from '../cupos/state/cupos.facade';

@Component({
  selector: 'app-portal-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, OverlayModule, TooltipModule],
  templateUrl: './portal-sidebar.component.html',
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
      .nav-scroll {
        scrollbar-width: thin;
        scrollbar-color: rgb(var(--ink) / 0.2) transparent;
      }
      .nav-scroll::-webkit-scrollbar {
        width: 6px;
      }
      .nav-scroll::-webkit-scrollbar-track {
        background: transparent;
      }
      .nav-scroll::-webkit-scrollbar-thumb {
        background: rgb(var(--ink) / 0.18);
        border-radius: 9999px;
      }
      .nav-scroll::-webkit-scrollbar-thumb:hover {
        background: rgb(var(--ink) / 0.32);
      }
    `,
  ],
})
export class PortalSidebarComponent {
  @Input() collapsed = false;
  @Output() toggleCollapse = new EventEmitter<void>();
  /** Se emite tras navegar; el layout lo usa para cerrar el drawer en móvil. */
  @Output() navigate = new EventEmitter<void>();

  readonly sections$: Observable<NavSection[]> = this.cuposFacade.hasCupos$.pipe(
    map((hasCupos) =>
      PORTAL_SECTIONS.map((section) => ({
        ...section,
        items: section.items.filter((item) => !item.requiresCupos || hasCupos),
      }))
    )
  );
  readonly userMenu = PORTAL_USER_MENU;
  readonly user$ = this.portalUser.user$;

  menuOpen = false;

  readonly overlayPositions: ConnectedPosition[] = [
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
      offsetY: -8,
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
      offsetY: 8,
    },
  ];

  constructor(
    public portalNav: PortalNavService,
    private readonly portalUser: PortalUserService,
    private readonly cuposFacade: CuposFacade,
    public theme: ThemeService,
  ) {}

  onNavigate(item: NavItem): void {
    this.menuOpen = false;
    this.portalNav.go(item);
    this.navigate.emit();
  }

  onToggleCollapse(): void {
    this.toggleCollapse.emit();
  }
}
